import { Injectable } from '@angular/core';
import { EmptyConstructor } from 'src/app/utils/alias.utils';

const TO_PROPERTY_KEY = 'toPropertyKey';
const EMBEDED_TYPE_KEY = 'embedTypeEntries';

/* Provides a method to convert data into the specified type. */
@Injectable({
  providedIn: 'root'
})
export class TypeTransformerUseCase {
  transformToType<Type>(typeConstructor: EmptyConstructor<Type>, data: Object): Type {
    const typeInstance = new typeConstructor();
    const target = typeConstructor.prototype;
    Object.assign(typeInstance, data);

    const toPropertyMapArray: ((target: any, source: any) => void)[] = target[TO_PROPERTY_KEY] || [];
    toPropertyMapArray.forEach((fromValue) => fromValue(typeInstance, data));

    const embedTypeArray: ((translator: TypeTransformerUseCase, target: any) => void)[] = target[EMBEDED_TYPE_KEY] || [];
    embedTypeArray.forEach((embedType) => embedType(this, typeInstance));

    return typeInstance;
  }
}

export function forKey(fromPropertyKey: string) {
  return (targetPrototype: any, propertyKey: string) => {
    const mapToProperty = (target: any, source: any) => {
      const sourceValue = source[fromPropertyKey];
      if (sourceValue !== undefined) {
        target[propertyKey] = sourceValue;

        if (fromPropertyKey !== propertyKey) {
          delete target[fromPropertyKey];
        }
      }
    };
    storeMappingFunction(targetPrototype, TO_PROPERTY_KEY, mapToProperty);
  };
}

/**
 * When translating outer type, this will run the type translator on the annotated property .
 * @param typeConstructor - The `typeConstructor` parameter is a constructor function that represents
 * the type of the property being decorated. It is used to determine the type of the property value and
 * perform any necessary transformations.
 */
export function embededType(typeConstructor: EmptyConstructor<any>) {
  return (targetPrototype: any, propertyKey: string) => {
    const transformToType = (translator: TypeTransformerUseCase, target: any) => {
      if (typeConstructor === target.constructor) {
        throw new Error('Cannot embed type into itself');
      }
      const translatedType = translator.transformToType(typeConstructor, target[propertyKey]);
      target[propertyKey] = translatedType;
    };
    storeMappingFunction(targetPrototype, EMBEDED_TYPE_KEY, transformToType);
  };
}

function storeMappingFunction(targetPrototype: any, storeKey: string, mappingFunction: (...args: any) => void) {
  const storedEntries = targetPrototype[storeKey];
  if (storedEntries == null) {
    targetPrototype[storeKey] = [];
  }
  targetPrototype[storeKey].push(mappingFunction);
}
